import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';
import { APP_CONFIG, API_CONFIG, MENU_COLOR, parseDatetimeLocal } from '../../contexts/constants';
import { formatDateCountdown, formatDateFooter } from '../../utils/dateFormatter';
import { showError } from '../../utils/sweetAlertConfig';
import { ICON_ACTION, ROLE_DISPLAY, ROLE_DISPLAY_NAVBAR, CUSTOMER_TIER_DISPLAY, CUSTOMER_TIER_DISPLAY_BADGE } from '../../contexts/constants';

const Layout = ({ title, children, onLogout, userRole, breadcrumbItems = null }) => {
	const [mobileOpen, setMobileOpen] = useState(false);
	const [isClosing, setIsClosing] = useState(false);
	const [openSubmenu, setOpenSubmenu] = useState(null); // Track which submenu is open
	const [accountDropdown, setAccountDropdown] = useState(false);
	const [currentTime, setCurrentTime] = useState(new Date());
	const [showLineContact, setShowLineContact] = useState(true);
  	const [openCountdowns, setOpenCountdowns] = useState([]); // Track which countdown widgets are opened (right-0)
	const location = useLocation(); // Get current location
	const accountRef = useRef(null);

	// Get userRole from localStorage if not provided via props
	const currentUserRole = userRole || localStorage.getItem('userRole') || null;
	const currentUserName = localStorage.getItem('name') || currentUserRole || '';
	const currentUserTier = localStorage.getItem('tier') || 'normal';

	let navLinks = [
		{
			label: 'ไม่พบกลุ่มสิทธิ์',
			to: '/404',
			icon: 'page'
		},
	];
	switch (currentUserRole) {
		case 'sysadmin':
		case 'owner':
			navLinks = [
				{
					label: 'ข้อมูลภาพรวม',
					to: '/dashboard',
					icon: 'dashboard',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					color: MENU_COLOR.done
				},
				{
					label: 'สมาชิก',
					to: '/agents/manage',
					icon: 'users_group',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'จัดการสมาชิก', to: '/agents/manage', icon: 'users', color: MENU_COLOR.done},
						{label: 'ตรวจสอบ/อนุมัติการชำระเงิน', to: '/bet/pay-waiting', icon: 'history', color: MENU_COLOR.done},
						{label: 'รายการสั่งซื้อของลูกค้า', to: '/members/history-bet', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'จัดการข้อมูล',
					to: '/manage_data/results-powerball',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'เพิ่มตาราง Powerball งวดใหม่', to: '/manage_data/prizes-manage-powerball', icon: 'cycle_check', color: MENU_COLOR.done},
						{label: 'เพิ่มตาราง Mega Millions งวดใหม่', to: '/manage_data/prizes-manage-megamillions', icon: 'cycle_check', color: MENU_COLOR.done},
						{label: 'รายการแก้ไขข้อมูล', to: '/manage_data/prizes-history', icon: 'history', color: MENU_COLOR.done},
						{label: 'สรุปผลรางวัล Powerball', to: '/manage_data/prizes-summary-powerball', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'สรุปผลรางวัล Mega Millions', to: '/manage_data/prizes-summary-megamillions', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'สรุปผลรางวัลย้อนหลัง', to: '/manage_data/prizes-summary-history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ผลรางวัล',
					to: '/results/winning',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ลูกค้าที่ถูกรางวัล', to: '/results/winning', icon: 'users_group', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Powerball ล่าสุด', to: '/results/results-powerball', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Mega Millions ล่าสุด', to: '/results/results-megamillions', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัลย้อนหลัง', to: '/results/history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'กติกาการเล่น',
					to: '/rules/view-powerball',
					icon: 'list_number',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'กติกาการเล่น Powerball', to: '/rules/view-powerball', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'กติกาการเล่น Mega Millions', to: '/rules/view-megamillions', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'จัดการกติกาการเล่น', to: '/rules/manage', icon: 'list', color: MENU_COLOR.done},
					]
				},
				{
					label: 'รายงาน',
					to: '/report/winning',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'รายการผู้ใช้งาน', to: '/report/members-winning', icon: 'list_down', color: MENU_COLOR.done},
						{label: 'รายการผู้ถูกรางวัล', to: '/report/winning', icon: 'list_down', color: MENU_COLOR.done},
						{label: 'รายงานจำนวนลูกค้าในเครือของตัวแทน', to: '/report/members-agent', icon: 'list_down', color: MENU_COLOR.done},
						{label: 'รายงานการสั่งซื้อ', to: '/report/credit-member-bet', icon: 'list_down', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ตั้งค่าระบบ',
					to: '/config',
					icon: 'settings',
					color: MENU_COLOR.done
				},
				{
					label: 'ข่าวสารและโปรโมชั่น',
					to: '/news/views',
					icon: 'news',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ข่าวสารและโปรโมชั่น', to: '/news/views', icon: 'news', color: MENU_COLOR.done},
						{label: 'จัดการข่าวสารและโปรโมชั่น', to: '/news/manage', icon: 'list', color: MENU_COLOR.done}
					]
				},
				{
					label: 'คู่มือการใช้งาน',
					to: '/user-manual',
					icon: 'book',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'ข้อมูลส่วนตัว',
					to: '/profile',
					icon: 'profile',
					status: 'hidden',
					color: MENU_COLOR.done
				},
			];
			break;

		case 'admin':
			navLinks = [
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					color: MENU_COLOR.done
				},
				{
					label: 'สมาชิก',
					to: '/members/manage',
					icon: 'users_group',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'จัดการสมาชิก', to: '/agents/manage', icon: 'users', color: MENU_COLOR.done},
						{label: 'ตรวจสอบ/อนุมัติการชำระเงิน', to: '/bet/pay-waiting', icon: 'history', color: MENU_COLOR.done},
						{label: 'รายการสั่งซื้อของลูกค้า', to: '/members/history-bet', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'จัดการข้อมูล',
					to: '/manage_data/results-powerball',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'เพิ่มตาราง Powerball งวดใหม่', to: '/manage_data/prizes-manage-powerball', icon: 'cycle_check', color: MENU_COLOR.done},
						{label: 'เพิ่มตาราง Mega Millions งวดใหม่', to: '/manage_data/prizes-manage-megamillions', icon: 'cycle_check', color: MENU_COLOR.done},
						{label: 'รายการแก้ไขข้อมูล', to: '/manage_data/prizes-history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ผลรางวัล',
					to: '/results/results-powerball',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ลูกค้าที่ถูกรางวัล', to: '/results/winning', icon: 'users_group', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Powerball ล่าสุด', to: '/results/results-powerball', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Mega Millions ล่าสุด', to: '/results/results-megamillions', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัลย้อนหลัง', to: '/results/history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'กติกาการเล่น',
					to: '/rules/view-powerball',
					icon: 'list_number',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'กติกาการเล่น Powerball', to: '/rules/view-powerball', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'กติกาการเล่น Mega Millions', to: '/rules/view-megamillions', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'จัดการกติกาการเล่น', to: '/rules/manage', icon: 'list', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ข่าวสารและโปรโมชั่น',
					to: '/news/views',
					icon: 'news',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ข่าวสารและโปรโมชั่น', to: '/news/views', icon: 'news', color: MENU_COLOR.done},
						{label: 'จัดการข่าวสารและโปรโมชั่น', to: '/news/manage', icon: 'list', color: MENU_COLOR.done}
					]
				},
				{
					label: 'คู่มือการใช้งาน',
					to: '/user-manual',
					icon: 'book',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'ข้อมูลส่วนตัว',
					to: '/profile',
					icon: 'profile',
					status: 'hidden',
					color: MENU_COLOR.done
				},
			];
			break;

		case 'agent':
			navLinks = [
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					color: MENU_COLOR.done
				},
				{
					label: 'ลูกค้า',
					to: '/members/manage',
					icon: 'users_group',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'จัดการลูกค้า', to: '/members/manage', icon: 'users_group', color: MENU_COLOR.done},
						{label: 'รายการสั่งซื้อของลูกค้า', to: '/members/history-bet', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ผลรางวัล',
					to: '/results/results-powerball',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ลูกค้าที่ถูกรางวัล', to: '/results/winning', icon: 'users_group', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Powerball ล่าสุด', to: '/results/results-powerball', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Mega Millions ล่าสุด', to: '/results/results-megamillions', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัลย้อนหลัง', to: '/results/history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'กติกาการเล่น',
					to: '/rules/view-powerball',
					icon: 'list_number',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'กติกาการเล่น Powerball', to: '/rules/view-powerball', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'กติกาการเล่น Mega Millions', to: '/rules/view-megamillions', icon: 'list_number', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ข่าวสารและโปรโมชั่น',
					to: '/news/views',
					icon: 'news',
					color: MENU_COLOR.done,
				},
				{
					label: 'คู่มือการใช้งาน',
					to: '/user-manual',
					icon: 'book',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'ข้อมูลส่วนตัว',
					to: '/profile',
					icon: 'profile',
					status: 'hidden',
					color: MENU_COLOR.done
				},
			];
			break;

		case 'customer':
			navLinks = [
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'หน้าแรก',
					to: '/home',
					icon: 'home',
					color: MENU_COLOR.done
				},
				{
					label: 'สั่งซื้อ',
					to: '/bet-order',
					icon: 'ticket',
					color: MENU_COLOR.done
				},
				{
					label: 'ผลรางวัล',
					to: '/results/results-powerball',
					icon: 'trophy',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'ผลรางวัล Powerball ล่าสุด', to: '/results/results-powerball', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัล Mega Millions ล่าสุด', to: '/results/results-megamillions', icon: 'trophy', color: MENU_COLOR.done},
						{label: 'ผลรางวัลย้อนหลัง', to: '/results/history', icon: 'history', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ประวัติการสั่งซื้อ',
					to: '/history/bet-action',
					icon: 'history',
					color: MENU_COLOR.done
				},
				{
					label: 'กติกาการเล่น',
					to: '/rules/view-powerball',
					icon: 'list_number',
					color: MENU_COLOR.done,
					subMenu: [
						{label: 'กติกาการเล่น Powerball', to: '/rules/view-powerball', icon: 'list_number', color: MENU_COLOR.done},
						{label: 'กติกาการเล่น Mega Millions', to: '/rules/view-megamillions', icon: 'list_number', color: MENU_COLOR.done},
					]
				},
				{
					label: 'ข่าวสารและโปรโมชั่น',
					to: '/news/views',
					icon: 'news',
					color: MENU_COLOR.done,
				},
				{
					label: 'คู่มือการใช้งาน',
					to: '/user-manual',
					icon: 'book',
					status: 'hidden',
					color: MENU_COLOR.done
				},
				{
					label: 'ข้อมูลส่วนตัว',
					to: '/profile',
					icon: 'profile',
					status: 'hidden',
					color: MENU_COLOR.done
				},
			];
			break;

		default:
			break;
	}

	// Helper function to check if any submenu item is active
	const isSubmenuActive = (subMenu) => {
		if (!subMenu) return false;
		return subMenu.some(sub => location.pathname === sub.to);
	};

	// Lock body scroll when drawer open
	useEffect(() => {
		if (mobileOpen) document.body.classList.add('overflow-hidden');
		else document.body.classList.remove('overflow-hidden');
		return () => document.body.classList.remove('overflow-hidden');
	}, [mobileOpen]);

	// Update current time every second
	useEffect(() => {
		const timer = setInterval(() => {
		setCurrentTime(new Date());
		}, 1000);
		return () => clearInterval(timer);
	}, []);

	// Check session validity every 10 minutes
	useEffect(() => {
		const checkSession = async () => {
			const token = localStorage.getItem('token');
			if (!token) return;

			try {
				const response = await fetch(`${API_CONFIG.BASE_URL}/check-session`, {
					method: 'GET',
					headers: {
						'Authorization': `Bearer ${token}`,
						'Content-Type': 'application/json'
					}
				});

				if (!response.ok) {
					// Session expired or invalid
					showError('เกิดข้อผิดพลาด', 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่', {
						showCloseButton: false,
						showCancelButton: false,
						showConfirmButton: false,
						allowOutsideClick: false,
						timer: 10000
					});

					// Wait 10 seconds before redirecting
					setTimeout(() => {
						const theme = localStorage.getItem('theme') || 'light';
						localStorage.clear();
						localStorage.setItem('theme', theme);
						window.location.href = '/login';
					}, 10000);
				}
			} catch (error) {
				console.error('Session check error:', error);
			}
		};

		// Check immediately when component mounts
		checkSession();

		// Then check every 10 minutes (600000ms)
		const interval = setInterval(checkSession, 600000);

		return () => clearInterval(interval);
	}, []);

	// Close submenu when clicking outside
	useEffect(() => {
		const handleClickOutside = (e) => {
			// Close only when clicking outside any submenu container (works for desktop and mobile)
			if (openSubmenu && !e.target.closest('.submenu-container')) {
				setOpenSubmenu(null);
			}
		};
		document.addEventListener('click', handleClickOutside);
		return () => document.removeEventListener('click', handleClickOutside);
	}, [openSubmenu]);

	// Close account dropdown when clicking outside
	useEffect(() => {
		if (!accountDropdown) return;
			const handleClick = (e) => {
			if (accountRef.current && !accountRef.current.contains(e.target)) {
				setAccountDropdown(false);
			}
		};
		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [accountDropdown]);

	const startClose = () => {
		setIsClosing(true);
		setTimeout(() => {
			setMobileOpen(false);
			setIsClosing(false);
		}, 200);
	};

  	const handleLinkClick = () => { if (mobileOpen) startClose(); };

	// Set document title by route or provided title
	useEffect(() => {
		const prefix = APP_CONFIG.APP_NAME;
		const page = title || generateBreadcrumb().map(b => b.label).join(' / ') || '';
		document.title = page ? `${page} | ${prefix}` : prefix;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname, title]);

	// Icon component mapper
	const getIcon = (iconType, className = "w-4 h-4") => {
		const icons = {
			home: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
				</svg>
			),
			dashboard: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z" />
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z" />
				</svg>
			),
			page: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
				</svg>
			),
			history: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
				</svg>
			),
			trophy: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
				</svg>
			),
			cycle_check: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
				</svg>
			),
			ticket: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
				</svg>
			),
			profile: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
				</svg>
			),
			users: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
				</svg>
			),
			users_group: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
				</svg>
			),
			news: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
				</svg>
			),
			settings: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
				</svg>
			),
			list: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
				</svg>
			),
			list_number: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99" />
				</svg>
			),
			list_down: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25" />
				</svg>
			),
			book: (
				<svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
				</svg>
			)
		};
		return icons[iconType] || null;
	};

	// Generate breadcrumb from current path
	const generateBreadcrumb = () => {
		const path = location.pathname;
		const breadcrumbs = [];

		// Find matching menu item
		navLinks.forEach(link => {
			if (link.subMenu) {
				// Check if any submenu matches current path
				const activeSubmenu = link.subMenu.find(sub => sub.to === path);
				if (activeSubmenu) {
					// Avoid pushing duplicate breadcrumb when parent link.to === submenu.to
					if (link.to && link.to !== activeSubmenu.to) {
						breadcrumbs.push({ label: link.label, path: link.to, icon: link.icon });
					} else {
            // use null to indicate non-clickable breadcrumb (do not use '#' which may affect routing)
            breadcrumbs.push({ label: link.label, path: null, icon: link.icon });
          }
					breadcrumbs.push({ label: activeSubmenu.label, path: activeSubmenu.to, icon: activeSubmenu.icon });
				} else if (path === link.to) {
					breadcrumbs.push({ label: link.label, path: link.to, icon: link.icon });
				}
			} else if (path === link.to) {
				breadcrumbs.push({label: link.label, path: link.to, icon: link.icon });
			}
		});

		return breadcrumbs;
	};

  	const breadcrumbs = breadcrumbItems || generateBreadcrumb();

	// Countdown data from API
	const [countdownData, setCountdownData] = useState([]);
	// LINE ID from API
	const [lineId, setLineId] = useState('');

	// Fetch countdown data from API
	useEffect(() => {
		fetchCountdowns();
		// Refresh every 5 minutes
		const interval = setInterval(fetchCountdowns, 5 * 60 * 1000);
		return () => clearInterval(interval);
	}, []);

	// Fetch LINE ID from API
	useEffect(() => {
		fetchLineContact();
	}, []);

	const fetchCountdowns = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) return;

			const response = await fetch(`${API_CONFIG.BASE_URL}/awards/countdowns`, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

			if (response.ok) {
				const data = await response.json();
				const countdownItems = Array.isArray(data)
					? data
					: (Array.isArray(data?.data) ? data.data : (Array.isArray(data?.countdowns) ? data.countdowns : []));
				// Convert targetDate string to Date object (local timezone)
				const countdowns = countdownItems.map(cd => ({
					...cd,
					targetDate: parseDatetimeLocal(cd.targetDate)
				}));

				setCountdownData(countdowns);
			}
		} catch (error) {
			console.error('Error fetching countdowns:', error);
		}
	};

	const fetchLineContact = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) return;

			const response = await fetch(`${API_CONFIG.BASE_URL}/config/line-contact`, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

			if (response.ok) {
				const result = await response.json();
				if (result.success && result.data.lineId) {
					setLineId(result.data.lineId);
				}
			}
		} catch (error) {
			console.error('Error fetching LINE ID:', error);
		}
	};

	const calculateTimeLeft = (targetDate) => {
		const difference = targetDate - currentTime;

		if (difference <= 0) {
			return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
		}

		return {
			days: Math.floor(difference / (1000 * 60 * 60 * 24)),
			hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
			minutes: Math.floor((difference / 1000 / 60) % 60),
			seconds: Math.floor((difference / 1000) % 60),
			expired: false
		};
	};

  // Toggle open state for a countdown widget
	const toggleCountdown = (id) => {
		setOpenCountdowns(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
	};

	const activeCountdowns = countdownData.filter((countdown) => {
		const timeLeft = calculateTimeLeft(countdown.targetDate);
		return !timeLeft.expired;
	});

	return (
		<div className="bg-watermark min-h-screen bg-background-light dark:bg-background-dark transition-colors duration-300 text-black flex flex-col">
			<nav className="relative bg-gradient-to-r from-blue-300 to-blue-200 dark:from-gray-700 dark:to-gray-650 dark:bg-gray-900 text-black dark:text-white shadow-light dark:shadow-lightdark border-b border-borderc-light dark:border-borderc-dark/60">
        <div className='mx-auto p-4'>
          <div className="flex items-center justify-between">
          <Link to={ navLinks[0].to } onClick={() => { setOpenSubmenu(navLinks[0].to); handleLinkClick(); }} className="group inline-flex items-center gap-3 hover:opacity-90 transition-opacity cursor-pointer">
            <img
              src={APP_CONFIG.LOGO_PATH}
              alt="Logo"
              className="w-9 h-9 rounded-md"
              loading="lazy"
              decoding="async"
            />
            <span className="text-3xl font-semibold text-black dark:text-white group-hover:opacity-95">{APP_CONFIG.APP_NAME}</span>
          </Link>
          <div className="flex items-center gap-3">
            <div className="hidden lg:flex items-center gap-1 xl:gap-2">
            {navLinks.map(l => (
              l.status === 'hidden' ? null : (
                l.subMenu ? (
                <div key={l.to} className="relative submenu-container">
                  <button
                  onClick={() => setOpenSubmenu(openSubmenu === l.to ? null : l.to)}
                  className={l.color+` px-1 py-2 xl:p-2 rounded-md transition-all duration-200 text-sm xl:text-base font-medium flex items-center gap-1 ${
                    openSubmenu === l.to || isSubmenuActive(l.subMenu)
                    ? 'dark:bg-white/30 text-blue-500 dark:text-white shadow-lg font-semibold scale-105'
                    : 'hover:bg-white/20 dark:hover:bg-white/10 text-black dark:text-white'
                  } `}
                  >
                  {l.label}
                  <svg className={`w-4 h-4 transition-transform ${openSubmenu === l.to ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                  </button>
                  {openSubmenu === l.to && (
                  <div className="absolute top-full left-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 py-2 z-50 submenu-container">
                    {l.subMenu.map(sub => (
                      sub.status === 'hidden' ? null : (
                        <NavLink
                          key={sub.to}
                        to={sub.to}
                          onClick={() => { setOpenSubmenu(null); handleLinkClick(); }}
                          className={({ isActive }) =>
                            `block px-4 py-2 text-sm transition-colors ${
                              isActive
                              ? 'bg-blue-500 text-white font-semibold'
                              : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
                            } ` + sub.color
                          }
                        >
                          {sub.label}
                        </NavLink>
                      )
                    ))}
                  </div>
                  )}
                </div>
                ) : (
                  <NavLink
                    key={l.to}
                    to={l.to}
                    end
                    onClick={handleLinkClick}
                    className={({ isActive }) =>
                    `${l.color} px-1 py-2 xl:p-2 rounded-md transition-all duration-200 text-sm xl:text-base font-medium ` +
                    (isActive
                      ? 'dark:bg-white/30 text-blue-500 dark:text-white shadow-lg font-semibold scale-105'
                      : 'hover:bg-white/20 dark:hover:bg-white/10 text-black dark:text-white hover:scale-102')
                    }
                  >
                    {l.label}
                  </NavLink>
                )
              )
            ))}
            {currentUserName && (
              <div className="flex items-center gap-2 px-2 relative" ref={accountRef}>
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/30 dark:bg-white/20">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                </svg>
              </div>
              <button
                type="button"
                className="flex flex-col items-start focus:outline-none ml-2"
                onClick={() => setAccountDropdown(v => !v)}
              >
                <span className="flex items-center gap-1 focus:outline-none">
                <span className="text-base font-medium text-black dark:text-white">{currentUserName}</span>
                {currentUserRole && (
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold shadow-sm ${ROLE_DISPLAY_NAVBAR[currentUserRole] || 'bg-gray-500 text-white'}`}>
                  {ROLE_DISPLAY[currentUserRole] || currentUserRole}
                  </span>
                )}
                </span>
                <span className="flex items-center gap-1">
                  {currentUserRole === 'customer' && (
					<>
						<small>ลูกค้าระดับ: </small>
						<span className={`px-2 py-0.5 rounded-md text-[9px] font-semibold ${CUSTOMER_TIER_DISPLAY_BADGE[currentUserTier] || CUSTOMER_TIER_DISPLAY_BADGE.normal}`}>
						{CUSTOMER_TIER_DISPLAY[currentUserTier] || 'Normal'}
						</span>
					</>
                  )}
                </span>
              </button>
              <button
                type="button"
                className="ml-1"
                onClick={() => setAccountDropdown(v => !v)}
                aria-label="Account menu"
              >
                <svg className={`w-5 h-5 transition-transform ${accountDropdown ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {accountDropdown && (
                <div className="absolute right-0 top-full mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 py-2 z-50 animate-fade-in">
                  <div className='px-4 py-2'>
                    <button onClick={() => { setOpenSubmenu(navLinks[navLinks.length-1].to); handleLinkClick(); window.location.href = navLinks[navLinks.length-1].to; }} className={`${navLinks[navLinks.length-1].color} rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105`}>
                      { getIcon(navLinks[navLinks.length-1].icon) }
                      { navLinks[navLinks.length-1].label }
                    </button>
                  </div>
				  <div className='px-4 py-2'>
                    <button onClick={() => { setOpenSubmenu(navLinks[navLinks.length-2].to); handleLinkClick(); window.location.href = navLinks[navLinks.length-2].to; }} className={`${navLinks[navLinks.length-2].color} rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105`}>
                      { getIcon(navLinks[navLinks.length-2].icon) }
                      { navLinks[navLinks.length-2].label }
                    </button>
                  </div>
                  <div className="px-4 py-2">
                    <ThemeToggle />
                  </div>
                  <div className='px-4 py-2'>
                    <button onClick={onLogout} className="rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105">
                      {ICON_ACTION.LOGOUT}
                      ออกจากระบบ
                    </button>
                  </div>
                </div>
              )}
              </div>
            )}
            </div>
            <button
            type="button"
            aria-label="Toggle menu"
            aria-expanded={mobileOpen}
            onClick={() => (mobileOpen ? startClose() : setMobileOpen(true))}
            className="lg:hidden inline-flex items-center justify-center p-2 rounded-md hover:bg-white/20 dark:hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/40 dark:focus:ring-white/30 focus:ring-offset-2 focus:ring-offset-transparent"
            >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-6 h-6">
              {mobileOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" />
              )}
            </svg>
            </button>
          </div>
          </div>
          {mobileOpen && (
          <>
            <div className="lg:hidden fixed inset-0 bg-black/70 dark:bg-black/70 z-40" onClick={startClose} aria-hidden="true"></div>
            <div className="lg:hidden">
            <div
              className={`fixed top-0 right-0 h-full w-72 max-w-[80%] bg-white dark:bg-neutral-900 text-black dark:text-white z-50 shadow-2xl border-l border-gray-200 dark:border-neutral-700 flex flex-col p-4 gap-3 transform will-change-transform ${isClosing ? 'animate-slide-out-to-right' : 'animate-slide-in-from-right'}`}
              role="dialog"
              aria-modal="true"
            >
              <div className="flex items-center justify-between mb-2">
              <span className="font-semibold text-base">เมนู</span>
              <button onClick={startClose} aria-label="Close menu" className="p-2 rounded-md hover:bg-white/20 dark:hover:bg-white/10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              </div>
              <div className="flex flex-col gap-2 flex-1 overflow-y-auto">
              {navLinks.map(l => (
                l.subMenu ? (
                  l.status === 'hidden' ? null : (
                    <div key={l.to} className="submenu-container">
                      <button
                      onClick={() => setOpenSubmenu(openSubmenu === l.to ? null : l.to)}
                      className={`${l.color} w-full px-4 py-2 rounded-md transition-all duration-200 text-base font-medium flex items-center justify-between ${
                        openSubmenu === l.to || isSubmenuActive(l.subMenu)
                        ? 'bg-blue-500 dark:bg-blue-600 text-white font-semibold shadow-lg'
                        : 'hover:bg-black/10 dark:hover:bg-white/10 text-black dark:text-white'
                      }`}
                      >
                      {l.label}
                      <svg className={`w-4 h-4 transition-transform ${openSubmenu === l.to ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                      </button>
                      {openSubmenu === l.to && (
                      <div className="ml-4 mt-1 flex flex-col gap-1">
                        {l.subMenu.map(sub => (
                          sub.status === 'hidden' ? null : (
                            <NavLink
                              key={sub.to}
                              to={sub.to}
                              onClick={() => { setOpenSubmenu(null); handleLinkClick(); }}
                              className={({ isActive }) =>
                              `${l.color} px-4 py-2 rounded-md text-sm transition-colors ${
                                isActive
                                ? 'bg-blue-400 dark:bg-blue-500 text-white font-semibold'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-black/10 dark:hover:bg-white/10'
                              }`
                              }
                            >
                              {sub.label}
                            </NavLink>
                          )
                        ))}
                      </div>
                      )}
                    </div>
                  )
                ) : (
                  l.status === 'hidden' ? null : (
                    <NavLink
                      key={l.to}
                      to={l.to}
                      end
                      onClick={handleLinkClick}
                      className={({ isActive }) =>
                      `${l.color} px-4 py-2 rounded-md transition-all duration-200 text-base font-medium ` +
                      (isActive
                        ? 'bg-blue-500 dark:bg-blue-600 text-white font-semibold shadow-lg scale-105 border-l-4 border-blue-700 dark:border-blue-400'
                        : 'hover:bg-black/10 dark:hover:bg-white/10 text-black dark:text-white')
                      }
                    >
                      {l.label}
                    </NavLink>
                  )
                )
              ))}
              </div>
              <div className="mt-auto flex flex-col gap-3 pt-2 border-t border-white/20 dark:border-white/10">
              {currentUserName && (
                <div className="flex items-center gap-2 px-1">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-black/10 dark:bg-white/20">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.8} stroke="currentColor" className="w-7 h-7">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                    </svg>
                  </div>
                  <div className="flex flex-col gap-1">
                    <span className="text-base font-medium">{currentUserName}</span>
                    <div className="flex items-center gap-2">
                      {currentUserRole && (
                        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold shadow-sm w-fit ${ROLE_DISPLAY_NAVBAR[currentUserRole] || 'bg-gray-500 text-white'}`}>
                          {ROLE_DISPLAY[currentUserRole] || currentUserRole}
                        </span>
                      )}
                      {currentUserRole === 'customer' && (
                        <span className={`px-2 py-0.5 rounded-md text-[10px] font-semibold ${CUSTOMER_TIER_DISPLAY_BADGE[currentUserTier] || CUSTOMER_TIER_DISPLAY_BADGE.normal}`}>
                          {CUSTOMER_TIER_DISPLAY[currentUserTier] || 'Normal'}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="">
                {onLogout && (
                  <>
                    <div className='px-4 py-2'>
                      <button onClick={() => { setOpenSubmenu(navLinks[navLinks.length-1].to); handleLinkClick(); window.location.href = navLinks[navLinks.length-1].to; }} className={navLinks[navLinks.length-1].color + `rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105` }>
                        { getIcon(navLinks[navLinks.length-1].icon) }
                        { navLinks[navLinks.length-1].label }
                      </button>
                    </div>
					<div className='px-4 py-2'>
                      <button onClick={() => { setOpenSubmenu(navLinks[navLinks.length-2].to); handleLinkClick(); window.location.href = navLinks[navLinks.length-2].to; }} className={navLinks[navLinks.length-2].color + `rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105` }>
                        { getIcon(navLinks[navLinks.length-2].icon) }
                        { navLinks[navLinks.length-2].label }
                      </button>
                    </div>
                    <div className='px-4 py-2'>
                      <button
                        onClick={onLogout}
                        className="rounded-full flex gap-2 items-center justify-center bg-white/80 dark:bg-gray-800/80 text-gray-700 dark:text-gray-200 hover:bg-white transition transform hover:scale-105"
                        title="ออกจากระบบ"
                        aria-label="ออกจากระบบ"
                        type="button"
                      >
                        {ICON_ACTION.LOGOUT}
                        ออกจากระบบ
                      </button>
                    </div>
                  </>
                )}
                <div className='px-4 py-2'>
                  <ThemeToggle />
                </div>
              </div>
              </div>
            </div>
            </div>
          </>
          )}
        </div>
			</nav>

			{/* Breadcrumb */}
			<div className="relative bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
				<div className="relative container mx-auto px-4 py-2">
					<nav className="flex" aria-label="Breadcrumb">
						{/* flex flex-col gap-2 flex-1 overflow-y-auto */}
					<ol className="inline-flex items-center space-x-1 md:space-x-3 overflow-hidden max-w-full">
						{breadcrumbs.map((crumb, index) => (
						<li key={`${crumb.path || crumb.label}-${index}`} className="inline-flex items-center flex-shrink-0">
							{index > 0 && (
							<svg className="w-4 h-4 text-gray-400 dark:text-gray-500 mx-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
								<path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
							</svg>
							)}
							{index === breadcrumbs.length - 1 ? (
								<span className="inline-flex items-center text-sm font-medium text-gray-500 dark:text-gray-400 max-w-[150px] sm:max-w-none truncate">
									{crumb.icon && <span className="mr-1.5 flex-shrink-0">{getIcon(crumb.icon)}</span>}
									<span className="truncate">{crumb.label}</span>
								</span>
							) : (
				// Render a Link only if crumb.path is a real route; otherwise render non-clickable text
				(crumb.path ? (
					<Link
					to={crumb.path}
					className="inline-flex items-center text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors max-w-[150px] sm:max-w-none truncate"
					>
					{crumb.icon && <span className="mr-1.5 flex-shrink-0">{getIcon(crumb.icon)}</span>}
					<span className="truncate">{crumb.label}</span>
					</Link>
				) : (
					<span className="inline-flex items-center text-sm font-medium text-gray-500 dark:text-gray-400 max-w-[150px] sm:max-w-none truncate">
					{crumb.icon && <span className="mr-1.5 flex-shrink-0">{getIcon(crumb.icon)}</span>}
					<span className="truncate">{crumb.label}</span>
					</span>
				))
							)}
						</li>
						))}
					</ol>
					</nav>
				</div>
			</div>

			<main className="relative container mx-auto p-4">
				{title && <h1 className="text-2xl sm:text-3xl font-semibold mb-6 sm:mb-8 text-black dark:text-white">{title}</h1>}
				{children}
			</main>

			{/* Footer */}
			<footer className="bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-auto">
				{activeCountdowns.length > 0 && (
					<section className="lg:hidden container mx-auto px-4 pt-4 space-y-2" aria-label="Countdown">
						{activeCountdowns.map((countdown) => {
							const timeLeft = calculateTimeLeft(countdown.targetDate);
							const timeUnits = [
								{ label: 'วัน', value: timeLeft.days },
								{ label: 'ชั่วโมง', value: String(timeLeft.hours).padStart(2, '0') },
								{ label: 'นาที', value: String(timeLeft.minutes).padStart(2, '0') },
								{ label: 'วินาที', value: String(timeLeft.seconds).padStart(2, '0') },
							];
							const isPowerball = countdown.type === 1;

							return (
								<div
									key={countdown.type}
									className={`overflow-hidden rounded-md border ${isPowerball ? 'border-red-200 dark:border-red-900/60 bg-red-50 dark:bg-red-950/30' : 'border-yellow-200 dark:border-yellow-900/60 bg-yellow-50 dark:bg-yellow-950/30'}`}
								>
									<div className="flex items-center gap-2.5 px-2.5 py-2">
										<div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
											<img src={countdown.imageSrc || ''} alt={countdown.title} className="h-7 w-7" loading="lazy" decoding="async" />
										</div>
										<div className="min-w-0 flex-1">
											<div className={`text-sm font-semibold truncate ${isPowerball ? 'text-red-700 dark:text-red-300' : 'text-yellow-800 dark:text-yellow-200'}`}>
												{countdown.title}
											</div>
											<p className="text-[11px] leading-4 text-gray-600 dark:text-gray-300">
												รางวัลจะออกเวลา {formatDateCountdown(countdown.targetDate)}
											</p>
										</div>
									</div>
									<div className="grid grid-cols-4 gap-1.5 px-2.5 pb-2.5 text-center">
										{timeUnits.map((unit) => (
											<div key={unit.label} className="rounded bg-white/80 dark:bg-gray-900/50 px-1 py-1.5">
												<div className={`text-base font-bold leading-5 ${isPowerball ? 'text-red-700 dark:text-red-200' : 'text-yellow-800 dark:text-yellow-100'}`}>
													{unit.value}
												</div>
												<div className="text-[9px] leading-3 text-gray-600 dark:text-gray-300">
													{unit.label}
												</div>
											</div>
										))}
									</div>
								</div>
							);
						})}
					</section>
				)}
				{showLineContact && lineId && (
					<section className="lg:hidden container mx-auto px-4 pt-3" aria-label="Line contact">
						<div className="flex items-center gap-2.5 rounded-md border border-green-200 bg-green-50 px-2.5 py-2 dark:border-green-900/60 dark:bg-green-950/30">
							<a
								href={`https://line.me/ti/p/${lineId}`}
								target="_blank"
								rel="noopener noreferrer"
								className="flex min-w-0 flex-1 items-center gap-2.5"
								aria-label="Contact us on LINE"
							>
								<span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
									<svg className="h-7 w-7 rounded-full fill-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path d="M311 196.8l0 81.3c0 2.1-1.6 3.7-3.7 3.7l-13 0c-1.3 0-2.4-.7-3-1.5L254 230 254 278.2c0 2.1-1.6 3.7-3.7 3.7l-13 0c-2.1 0-3.7-1.6-3.7-3.7l0-81.3c0-2.1 1.6-3.7 3.7-3.7l12.9 0c1.1 0 2.4 .6 3 1.6l37.3 50.3 0-48.2c0-2.1 1.6-3.7 3.7-3.7l13 0c2.1-.1 3.8 1.6 3.8 3.5l0 .1zm-93.7-3.7l-13 0c-2.1 0-3.7 1.6-3.7 3.7l0 81.3c0 2.1 1.6 3.7 3.7 3.7l13 0c2.1 0 3.7-1.6 3.7-3.7l0-81.3c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1l-35.6 0 0-64.4c0-2.1-1.6-3.7-3.7-3.7l-13 0c-2.1 0-3.7 1.6-3.7 3.7l0 81.3c0 1 .3 1.8 1 2.5 .7 .6 1.5 1 2.5 1l52.2 0c2.1 0 3.7-1.6 3.7-3.7l0-13c0-1.9-1.6-3.7-3.5-3.7l.1 0zm193.7-68.1l-52.3 0c-1.9 0-3.7 1.6-3.7 3.7l0 81.3c0 1.9 1.6 3.7 3.7 3.7l52.2 0c2.1 0 3.7-1.6 3.7-3.7l0-13.1c0-2.1-1.6-3.7-3.7-3.7l-35.5 0 0-13.6 35.5 0c2.1 0 3.7-1.6 3.7-3.7l0-13.1c0-2.1-1.6-3.7-3.7-3.7l-35.5 0 0-13.7 35.5 0c2.1 0 3.7-1.6 3.7-3.7l0-13c-.1-1.9-1.7-3.7-3.7-3.7l.1 0zM512 93.4l0 326c-.1 51.2-42.1 92.7-93.4 92.6l-326 0C41.4 511.9-.1 469.8 0 418.6l0-326C.1 41.4 42.2-.1 93.4 0l326 0c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3S68.8 150.1 68.8 233.5c0 74.7 66.3 137.4 155.9 149.3 21.8 4.7 19.3 12.7 14.4 42.1-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1l0-.2z"/>
									</svg>
								</span>
								<span className="min-w-0">
									<span className="block truncate text-sm font-semibold text-green-700 dark:text-green-300">ติดต่อผ่าน LINE</span>
									<span className="block truncate text-[11px] leading-4 text-gray-600 dark:text-gray-300">{lineId}</span>
								</span>
							</a>
							<button
								onClick={() => setShowLineContact(false)}
								className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-black/10 hover:text-gray-700 dark:text-gray-300 dark:hover:bg-white/10"
								aria-label="Close LINE contact"
								type="button"
							>
								<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-4 w-4">
									<path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</button>
						</div>
					</section>
				)}
				<div className="container mx-auto px-4 py-6">
				<div className="flex flex-col md:flex-row justify-between items-center gap-4">
					{/* Copyright */}
					<div className="text-sm text-gray-600 dark:text-gray-400">
					© {new Date().getFullYear()} <span className="font-semibold text-gray-900 dark:text-white">{APP_CONFIG.APP_NAME}</span>. All rights reserved.
					</div>
					{/* Time and Version */}
					<div className="flex items-center gap-4">
					<div className="text-sm text-gray-600 dark:text-gray-400 font-mono">
						เวลาตอนนี้: {formatDateFooter(currentTime)}
					</div>
					<div className="text-xs text-gray-500 dark:text-gray-500">{APP_CONFIG.VERSION}</div>
					</div>
				</div>
				</div>
			</footer>

			{/* Countdown Floating Widget */}
			<div className="hidden lg:block">
				{activeCountdowns.map((countdown) => {
					const timeLeft = calculateTimeLeft(countdown.targetDate);
					return (
            <div
              key={countdown.type}
              className={`countdown-box fixed z-40 flex flex-col gap-3 transition-all duration-300 ${openCountdowns.includes(countdown.type) ? 'right-0' : '-right-[280px]'} ${activeCountdowns.length === 2 ? (countdown.type === 1 ? 'bottom-[250px]' : 'bottom-6') : 'bottom-6'}`}
            >
              <div
                className={`flex items-center justify-center bg-opacity-20 hover:bg-opacity-30 transition-colors rounded-l-lg mt-10`}
                style={{ 'backgroundColor': countdown.color }}
              >
                <div id={`countdown-${countdown.type}`}
                  className="relative flex items-center justify-center h-full cursor-pointer"
                  onClick={() => toggleCountdown(countdown.type)}
                >
                  <div className="absolute bottom-full left-2 bg-red-500 text-white text-xs font-bold rounded-full w-8 h-8 text-center flex items-center justify-center shadow-lg mb-1">
                    <img src={countdown.imageSrc || ''} alt={countdown.title} className="w-8 h-8 text-center" loading="lazy" decoding="async" />
                  </div>
                  <div
                    className='relative flex flex-col items-center justify-center gap-[2px] p-1'
                  >
                    <div className='flex flex-col justify-center w-10 h-10 text-center bg-white dark:bg-white/50 backdrop-blur-sm rounded-full p-1'>
                      <div className='w-5 h-5 font-bold mx-auto'>{timeLeft.days}</div>
                      <div className='text-[10px] text-gray-600 dark:text-gray-600'>วัน</div>
                    </div>
                    <div className='flex flex-col justify-center w-10 h-10 text-center bg-white dark:bg-white/50 backdrop-blur-sm rounded-full p-1'>
                      <div className='w-5 h-5 font-bold mx-auto'>{String(timeLeft.hours).padStart(2, '0')}</div>
                      <div className='text-[10px] text-gray-600 dark:text-gray-600'>ชั่วโมง</div>
                    </div>
                    <div className='flex flex-col justify-center w-10 h-10 text-center bg-white dark:bg-white/50 backdrop-blur-sm rounded-full p-1'>
                      <div className='w-5 h-5 font-bold mx-auto'>{String(timeLeft.minutes).padStart(2, '0')}</div>
                      <div className='text-[10px] text-gray-600 dark:text-gray-600'>นาที</div>
                    </div>
                    <div className='flex flex-col justify-center w-10 h-10 text-center bg-white dark:bg-white/50 backdrop-blur-sm rounded-full p-1'>
                      <div className='w-5 h-5 font-bold mx-auto'>{String(timeLeft.seconds).padStart(2, '0')}</div>
                      <div className='text-[10px] text-gray-600 dark:text-gray-600'>วินาที</div>
                    </div>
                  </div>
                </div>
                <div
                  className={`relative ${countdown.type === 1 ? 'text-white dark:text-white' : 'text-gray-800 dark:text-gray-800'} h-full min-w-[280px] max-w-[360px] animate-fade-in backdrop-blur-sm`}
                >
                  <div className={`absolute -top-[.4rem] left-0 w-full h-[108%] bg-gradient-to-r from-[${countdown.color}] to-black/20`}></div>
                  <div className="relative">
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <h3 className="text-sm font-semibold flex items-center gap-2 mb-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        {countdown.title}
                        </h3>
                        <p className="text-xs text-left opacity-90 mt-1">
                        รางวัลจะออกเวลา<br />{formatDateCountdown(countdown.targetDate)}
                        </p>
                      </div>
                      <button
                        onClick={() => toggleCountdown(countdown.type)}
                        className={`${countdown.type === 1 ? 'text-white dark:text-white' : 'text-gray-800 dark:text-gray-800'} hover:text-gray-900 dark:hover:text-white transition-colors p-1 hover:bg-black/10 dark:hover:bg-white/10 rounded flex-shrink-0`}
                        aria-label="ปิด"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>

                    <div className="grid grid-cols-4 gap-2 text-center">
                    <div className="bg-white/40 dark:bg-white/10 backdrop-blur-sm rounded-lg p-1">
                      <div className="text-lg font-bold">{timeLeft.days}</div>
                      <div className="text-xs opacity-90">วัน</div>
                    </div>
                    <div className="bg-white/40 dark:bg-white/10 backdrop-blur-sm rounded-lg p-1">
                      <div className="text-lg font-bold">{String(timeLeft.hours).padStart(2, '0')}</div>
                      <div className="text-xs opacity-90">ชั่วโมง</div>
                    </div>
                    <div className="bg-white/40 dark:bg-white/10 backdrop-blur-sm rounded-lg p-1">
                      <div className="text-lg font-bold">{String(timeLeft.minutes).padStart(2, '0')}</div>
                      <div className="text-xs opacity-90">นาที</div>
                    </div>
                    <div className="bg-white/40 dark:bg-white/10 backdrop-blur-sm rounded-lg p-1">
                      <div className="text-lg font-bold">{String(timeLeft.seconds).padStart(2, '0')}</div>
                      <div className="text-xs opacity-90">วินาที</div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
					);
				})}
			</div>

      {/* Line Contact */}
      { showLineContact && lineId && (
        <div className="group fixed bottom-6 right-16 z-50 hidden lg:block">
          <a
            href={`https://line.me/ti/p/${lineId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center"
            aria-label="Contact us on LINE"
          >
            <svg className="rounded-full fill-green-500 group-hover:fill-green-700 transition-colors" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M311 196.8l0 81.3c0 2.1-1.6 3.7-3.7 3.7l-13 0c-1.3 0-2.4-.7-3-1.5L254 230 254 278.2c0 2.1-1.6 3.7-3.7 3.7l-13 0c-2.1 0-3.7-1.6-3.7-3.7l0-81.3c0-2.1 1.6-3.7 3.7-3.7l12.9 0c1.1 0 2.4 .6 3 1.6l37.3 50.3 0-48.2c0-2.1 1.6-3.7 3.7-3.7l13 0c2.1-.1 3.8 1.6 3.8 3.5l0 .1zm-93.7-3.7l-13 0c-2.1 0-3.7 1.6-3.7 3.7l0 81.3c0 2.1 1.6 3.7 3.7 3.7l13 0c2.1 0 3.7-1.6 3.7-3.7l0-81.3c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1l-35.6 0 0-64.4c0-2.1-1.6-3.7-3.7-3.7l-13 0c-2.1 0-3.7 1.6-3.7 3.7l0 81.3c0 1 .3 1.8 1 2.5 .7 .6 1.5 1 2.5 1l52.2 0c2.1 0 3.7-1.6 3.7-3.7l0-13c0-1.9-1.6-3.7-3.5-3.7l.1 0zm193.7-68.1l-52.3 0c-1.9 0-3.7 1.6-3.7 3.7l0 81.3c0 1.9 1.6 3.7 3.7 3.7l52.2 0c2.1 0 3.7-1.6 3.7-3.7l0-13.1c0-2.1-1.6-3.7-3.7-3.7l-35.5 0 0-13.6 35.5 0c2.1 0 3.7-1.6 3.7-3.7l0-13.1c0-2.1-1.6-3.7-3.7-3.7l-35.5 0 0-13.7 35.5 0c2.1 0 3.7-1.6 3.7-3.7l0-13c-.1-1.9-1.7-3.7-3.7-3.7l.1 0zM512 93.4l0 326c-.1 51.2-42.1 92.7-93.4 92.6l-326 0C41.4 511.9-.1 469.8 0 418.6l0-326C.1 41.4 42.2-.1 93.4 0l326 0c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3S68.8 150.1 68.8 233.5c0 74.7 66.3 137.4 155.9 149.3 21.8 4.7 19.3 12.7 14.4 42.1-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1l0-.2z"/>
            </svg>
          </a>
          <button onClick={() => setShowLineContact(false)} className="absolute -top-2 -right-2 w-6 h-6 bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-full flex items-center justify-center shadow-md opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Close LINE contact">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}
		</div>
	);
};

export default Layout;
